import { Fragment } from 'preact';
import { SvgIcon } from '@/features/form';

export default function CustomThumbSelectable({ customThumb = {} }) {
	return (
		<Fragment>
			{customThumb.type === 'img' && (
				<img
					src={customThumb.img}
					alt={customThumb.alt}
					style={{
						verticalAlign: 'middle',
						maxWidth: 40,
						width: '100%'
					}}
				/>
			)}
			{customThumb.type === 'svg' && (
				<SvgIcon
					customIcon={customThumb}
					style={{ verticalAlign: 'middle' }}
					alt={customThumb.alt}
				/>
			)}
		</Fragment>
	);
}
